import type { UpdateUserProfile200PreferencesTheme } from './updateUserProfile200PreferencesTheme';

export type UpdateUserProfile200Preferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: UpdateUserProfile200PreferencesTheme;
};
